export default __webpack_public_path__ + "static/media/bg-login.02f4a1ce.png";